import { Header } from "src/apps/components/header/Header";
import { BaseScreen } from "../../components/baseScreen/BaseScreen";

import { CenteredContainer } from "./components/CenteredContainer";
import { ConsentsForm } from "./components/ConsentsForm";
import { colors } from "@permisso/permisso-components";

export const ConsentsScreen = () => {
  return (
    <BaseScreen
      backgroundColor={colors.grey0}
      header={<Header />}
      screenPadding="32px"
      mobileScreenPadding="20px"
    >
      <CenteredContainer>
        <ConsentsForm />
      </CenteredContainer>
    </BaseScreen>
  );
};
